import {
  checkIsStringEmpty,
  IBookingQuestions,
} from "@my-scoot/exly-react-component-lib";
import { question_type_id } from "constants/customerQuestions.constants";
import { is_empty } from "features/Common/utils/common.utils";
import { IListingQuestions } from "../ListingQuestions.interfaces";
import { QUESTION_TYPE_IDS } from "features/Account/modules/Communications/modules/ContactForm/modules/QuestionForm/modules/common/QuestionFormFields/constants/QuestionFormFields.constants";
import { LISTING_DEFAULT_QUESTIONS_KEYS } from "../constants/QuestionFormList.constants";

export const isMultiQuestionType = (type?: number) => {
  if (!type) return false;
  return [question_type_id.PAN, question_type_id.GST].includes(type);
};

export const transformListingFormQuestionsList = (data: any[] = []) => {
  if (is_empty(data)) return [];
  try {
    const transformedData = data.map((item) => ({
      ...item,
      _id: item.uuid,
      isDragDisabled: item.is_default,
    }));
    return transformedData;
  } catch (error) {
    return data;
  }
};

export const filterBookingQuestions = ({
  data,
  questionPlacement,
}: {
  data: IBookingQuestions.IQuestion[];
  questionPlacement: number;
}) => data?.filter((ques) => ques?.question_placement == questionPlacement);

export const isDefaultTypeQuestion = ({
  question,
}: {
  question: IListingQuestions.IQuestionsFormData;
}) => {
  return (
    [QUESTION_TYPE_IDS.EMAIL, QUESTION_TYPE_IDS.PHONE_NUMBER].includes(
      question?.type
    ) ||
    (QUESTION_TYPE_IDS.SHORT_TEXT && question?.is_default == true)
  );
};

export const getFeatureKeyAndValueForDefaultTypeQuestion = ({
  question,
  value,
}: {
  question: IListingQuestions.IQuestionsFormData;
  value: IListingQuestions.IQuestionsFormData;
}): { feature_key: string; feature_value: string | boolean } | {} => {
  const valueGotUpdated =
    !checkIsStringEmpty(value?.question) || "enable_otp_verification" in value;
  if (!valueGotUpdated) return {};

  if (
    question?.type === QUESTION_TYPE_IDS.SHORT_TEXT &&
    question?.is_default === true
  ) {
    return {
      feature_key: LISTING_DEFAULT_QUESTIONS_KEYS.NAME,
      feature_value: value.question,
    };
  }

  if (question?.type === QUESTION_TYPE_IDS.EMAIL) {
    return {
      feature_key: LISTING_DEFAULT_QUESTIONS_KEYS.EMAIL,
      feature_value: value.question,
    };
  }

  if (question?.type === QUESTION_TYPE_IDS.PHONE_NUMBER) {
    if ("enable_otp_verification" in value) {
      return {
        feature_key: LISTING_DEFAULT_QUESTIONS_KEYS.ENABLE_OTP_VERIFICATION,
        feature_value: value?.enable_otp_verification,
      };
    }
    return {
      feature_key: LISTING_DEFAULT_QUESTIONS_KEYS.PHONE,
      feature_value: value.question,
    };
  }

  return {};
};
